export const banner = {
  loading: "読み込み中",
  alt: {
    purchaseFirst: "初回購入ボーナス",
    purchaseSecond: "2回目購入ボーナス",
    purchaseThird: "3回目購入ボーナス",
    purchaseFourth: "4回目購入ボーナス",
    purchaseFifth: "5回目購入ボーナス",
    applePayCreditList: "Apple Pay・クレジットカード決済なら10%ポイント増量",
    dailyBonus: "デイリーボーナス",
    lovense: "Lovense フルコントロール",
    webPayment: "Web決済でお得にポイント購入",
    spuPointBack: "SPUポイントバック",
    reviewReward: "レビュー投稿で50ptもらえる",
    paidy: "Paidyあと払い お支払いは翌月でOK",
    campaignEimi: "深田えいみコラボイベント開催！",
    campaignEimiPointBack: "超ポイント還元祭！最大6,000pt還元",
    campaignEimiPointRanking: "ポイント消費 王座決定戦",
    campaignEimiPresent: "深田えいみの豪華景品をGET！",
    campaignEimiLivePart2: "深田えいみ第2弾ライブ配信 8/31(月)20時スタート！",
    videoCallPointBack: "秋のポイントバックキャンペーン",
    newUserPointBack: "新規会員さま限定 ポイントバックキャンペーン",
    missionMakingCall: "ビデオ通話ミッション",
    findTypeGirl: "好みの女の子が見つかりやすい！",
    searchGirls: "検索機能で好みの女の子とマッチ率UP！",
    saveOnPoints: "カード・Apple Payでポイント購入が最大1200ptお得に",
    sakuraStoreUnpublishedNotice:
      "Sakuraは一時的にストアから非公開にしております アンインストールしないようお願いします",
  },
} as const;
